
const {ccclass, property} = cc._decorator;

@ccclass('ButtonGrey')
class ButtonGrey
{
    @property(cc.String)
    key: string = "";
    @property(cc.Button)
    btn: cc.Button = null;
    @property(cc.Node)
    bg: cc.Node = null;
    @property(cc.Node)
    greyBg: cc.Node = null;
}

@ccclass
export class SlotButtonGrey extends cc.Component {
    @property(ButtonGrey)
    btns:ButtonGrey[] = [];

    private getButtonByName(key: string){
        for (let idx = 0; idx < this.btns.length; idx++) {
            let btn = this.btns[idx];
            if (btn.key == key) {
                return btn;
            }
        }
        return null;
    }

    setButtonGrey(key:string,grey:boolean){
        let btn = this.getButtonByName(key);
        if(btn){
            btn.bg.active = !grey
            btn.greyBg.active = grey
            btn.btn.enabled = !grey
        }       
    }

}
